// extracted by mini-css-extract-plugin
module.exports = {"container":"RuleConfig_container__3e37C","description":"RuleConfig_description__2iI2R","rule":"RuleConfig_rule__3cwMh"};